import { render, staticRenderFns } from "./courtsTrash.vue?vue&type=template&id=6b72b44e&scoped=true"
import script from "./courtsTrash.vue?vue&type=script&lang=js"
export * from "./courtsTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b72b44e",
  null
  
)

export default component.exports